import PropTypes from 'prop-types';
import React from 'react'
import { browserHistory, Link } from 'react-router-dom'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Icon } from '~/components'
import TextEdit from '~/services/textedit'

import TextLoader from '~/components/Loaders/TextLoader'

import { requestCampNotification } from '~/actions/camps'


class Sidebar extends React.Component {
    static propTypes = {
		camps: PropTypes.array,
		selectedCamp: PropTypes.string,
		fetching: PropTypes.bool
	};

    constructor(props, context) {
        super(props, context);
        var { width, height } = this.getDimensions();

        this.state = {
			collapsed: true,
			mobile: width < this.mobileBreakpoint
		};
    }

    mobileBreakpoint = 768;

    componentWillMount() {
        this.updateDimensions();
    }

    componentDidMount() {
		window.addEventListener("resize", this.updateDimensions);
	}

    getDimensions = () => {
        var w = window,
	        d = document,
	        documentElement = d.documentElement,
	        body = d.getElementsByTagName('body')[0],
	        width = w.innerWidth || documentElement.clientWidth || body.clientWidth,
	        height = w.innerHeight || documentElement.clientHeight || body.clientHeight;
        return { width, height }
	};

    updateDimensions = () => {

		var { width, height } = this.getDimensions();

        if( width >= this.mobileBreakpoint && !!this.state.collapsed ) {
        	this.setState({collapsed: false, mobile: false})
        } else if( width < this.mobileBreakpoint && !this.state.collapsed ) {
        	this.setState({collapsed: true, mobile: true})
        }

    };

    requestCampNotification = () => {
		this.props.requestCampNotification()
	};

    toggleVisible = () => {
		this.setState({
			collapsed: !this.state.collapsed
		})
	};

    render() {

		let camps = this.props.camps.sort((a,b) => {
			if( a.date < b.date ) return -1
			if( a.date > b.date ) return 1
			return 0
		})

		return (

			<div>
				{ this.props.fetching
					? <TextLoader />
					: ('camps' in this.props) && camps.length > 0 
						? <div>
							<div className="hidden-md hidden-lg" onClick={this.toggleVisible}>
								<div className="tab"><Icon icon={this.state.mobile ? 'menu' : 'camps'} /> <strong>Camps</strong></div>
							</div>
							<div className="collapsable" style={{height: this.state.collapsed ? '0' : '100%'}}>
								<div id="campList">
									{ camps.map( camp => {
										return <div className={"side-tab camp-tab " + (this.props.selectedCamp === camp.slug ? 'selected' : '')} key={'camp-filter-'+camp.ID}>
											<p>
												<Link to={this.props.selectedCamp === camp.slug ? '/' : camp.link}>
													{ TextEdit.cutText(camp.title, camp.status == 'admin' ? 10 : 13) + (camp.status == 'admin' ? ' (A)' : '')}
												</Link>
											</p>
										</div>
									}) }
								</div>
								<p className="small mleft20 mtop10 clickable text-dark-gray" id="newCamp" onClick={this.requestCampNotification}>
									<i className="icon-plus"></i> Create a Camp
								</p>
							</div>
						</div>
						: <p className="small mleft20 mtop10">No camps</p>
				}
        	</div>

		)

	}

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions);
    }
}

const mapStateToProps = state => ({
    camps: state.session.camps || [],
	fetching: state.session.fetching.camps
});

const mapDispatchToProps = dispatch => bindActionCreators({ requestCampNotification }, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)( Sidebar );




// WEBPACK FOOTER //
// ./src/js/views/Community/SideBarLeft/SideBar-Camps.jsx